export default __webpack_public_path__ + "static/media/kitchen3-before2-480w.d651c0dd.avif";